import Cookies from 'js-cookie';
import getActiveExperimentVariant from './helpers/optimize';
import { fetchData } from '../helpers/base_data_fetcher';

function removeCookie() {
  Cookies.remove('ab_test_srp');
}

async function triggerExperiment({ experiment_id, dataLayer }) {
  dataLayer.push({
    event: 'optimize.activate.desktop_srp_cards_more_info',
  });
  try {
    const variant = await getActiveExperimentVariant(experiment_id);
    if (variant != 0) {
      return Cookies.set('ab_test_srp', 1, { expires: 14 });
    }
    return removeCookie();
  } catch (error) {
    return removeCookie();
  }
}

function desktop_card_toggle() {
  fetchData('experiments').then((experiments) => {
    const experiment_id = experiments.desktop_srp_cards_more_info;
    triggerExperiment({
      experiment_id,
      dataLayer: window.dataLayer,
    });
  });
}

export default desktop_card_toggle;
